import type { QueryClient } from '@tanstack/react-query'
import type { NotificationUnreadCountResponse } from '@/api/generated/models'

export const UNREAD_COUNT_KEY = ['notifications', 'unreadCount'] as const

// Optimistically drop the bell's unread badge by one, synchronously, at click
// time. The mark-read mutations call this from `onMutate` (which runs before
// the click handler's navigate()/onClose() unmounts the component). Relying on
// the mutation's `onSuccess` instead leaves the badge stale on a linked-
// notification click: React Query v5 does NOT fire a mutation's `onSuccess`
// once the owning component has unmounted, so the follow-up invalidation never
// runs and the badge keeps its old count until the next poll. The optimistic
// value is exact (one unread item became read); the 60s poll / window-focus
// refetch reconcile with server truth regardless.
export function decrementUnreadCount(queryClient: QueryClient): void {
  queryClient.setQueryData<NotificationUnreadCountResponse>(UNREAD_COUNT_KEY, (old) =>
    old && typeof old.count === 'number' ? { ...old, count: Math.max(0, old.count - 1) } : old,
  )
}
